var render, staticRenderFns
import script from "./contactsidebar.vue?vue&type=script&lang=js&"
export * from "./contactsidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7b47c6c')) {
      api.createRecord('d7b47c6c', component.options)
    } else {
      api.reload('d7b47c6c', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-8JzuhB2N9G6vH/JS/comp/contactsidebar.vue"
export default component.exports